import React from 'react';

export const ResizeIcon = () => (
  <svg width="10" height="10" focusable="false"
       // style="{fill:gray;}"
  >
    <g fillRule="nonzero">
      <path d="M8.1 1.1A.5.5 0 119 2l-7 7A.5.5 0 111 8l7-7zM8.1 5.1A.5.5 0 119 6l-3 3A.5.5 0 115 8l3-3z"></path>
    </g>
  </svg>
);
